<template>
  <SectionFrame v-if="items.length" :section="section" :index="index" :heading="section.title || 'Questions people ask'" label="Questions" :narrow="true">
    <div class="s2-faq mo-stagger">
      <details v-for="(it, i) in items" :key="i" class="s2-faq-item" :open="layout === 'open' || null">
        <summary><span>{{ it.question }}</span><span class="s2-faq-icon" aria-hidden="true">+</span></summary>
        <div class="t-body s2-faq-answer" v-html="answer(it.answer)"></div>
      </details>
    </div>
  </SectionFrame>
</template>

<script setup>
import {computed} from "vue";
import SectionFrame from "./SectionFrame.vue";
import {layoutOf} from "@/utils/sectionLogic.js";
import {safeMarkdown} from "@/utils/safeMarkdown.js";

const props = defineProps({section: {type: Object, required: true}, index: {type: Number, default: 0}});
const layout = computed(() => layoutOf(props.section, ["list", "open"]));
const items = computed(() => (Array.isArray(props.section.items) ? props.section.items : [])
  .filter((i) => i && typeof i.question === "string" && i.question.trim()));
const answer = (a) => safeMarkdown(a || "");
</script>

<style>
.s2-faq-item { border-bottom: 1px solid var(--t-line); }
.s2-faq-item summary { list-style: none; display: flex; justify-content: space-between; gap: 1rem; padding: 1.1rem 0; cursor: pointer; font-weight: 700; font-size: 1.05rem; }
.s2-faq-item summary::-webkit-details-marker { display: none; }
.s2-faq-item summary:focus-visible { outline: 3px solid var(--t-accent); outline-offset: 2px; }
.s2-faq-icon { transition: transform .2s ease; font-size: 1.3rem; line-height: 1; color: var(--t-accent); }
.s2-faq-item[open] .s2-faq-icon { transform: rotate(45deg); }
.s2-faq-answer { padding: 0 0 1.2rem; color: var(--t-muted); }
@media (prefers-reduced-motion: reduce) { .s2-faq-icon { transition: none; } }
</style>
